import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store'
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'vue2-datepicker/index.css';
import './assets/custom.scss';
import './assets/styles/_variables.scss'
import './assets/styles/global.scss'
import 'animate.css';

Vue.config.productionTip = false;

new Vue({
  render: h => h(App),
  store,
  router,
}).$mount('#app');
